(function(){
  function init(){
    var videos = document.querySelectorAll(".product-video-inline video, .product-video-autoplay video");
    if (!videos.length) return;
    videos.forEach(function(video){
      video.muted = true;
      video.loop = true;
      video.playsInline = true;
      video.setAttribute("playsinline","");
      video.setAttribute("webkit-playsinline","");
      video.setAttribute("muted","");
      video.setAttribute("loop","");
      video.removeAttribute("controls");
      if ("IntersectionObserver" in window){
        var obs = new IntersectionObserver(function(entries){
          entries.forEach(function(entry){
            if(entry.isIntersecting){
              entry.target.play().catch(function(){});
            } else {
              entry.target.pause();
            }
          });
        },{threshold:0.3});
        obs.observe(video);
      }
    });
  }
  if(document.readyState==="loading"){
    document.addEventListener("DOMContentLoaded",init);
  } else {
    init();
  }
})();
